import React from 'react'
import { ImageObject, menuContent } from '../../../contenful/types';
import { InternalLink, richTextOptionsSideMenu } from '../../../landingpage/pagesection/HeroBannerTwoColumnsComponent';
import { renderContentAsComponent } from '../../../contentutils';
import DOMPurify from 'dompurify';
import { useSelector } from 'react-redux';
import { AppState } from '../../../RootReducer';

/**
 * SideMenuContent component used in Absolute and Fixed side menu.
 * @returns SideMenuContent
 */
export default function SideMenuContent({ content, isLoggedIn, classname }: { content: menuContent; isLoggedIn?: boolean; classname?: string }) {
    return (
        <div className={`menu-content ${classname} menu-content-fixed`}>
            <div key={content.title} className={`side-menu-content ${isLoggedIn ? "isLoggedIn" : "isLoggedOut"}`}>
                {content && content.image && (
                    <div className="img-content">
                        <div className={"image"} style={{ backgroundImage: `url('${csmImageUrl(content?.image)}')` }}></div>
                    </div>
                )}
                {content && (content.title || content.tagline) && (
                    <div className={"text"}>
                        {content.title && <div className={"title"}>{content.title}</div>}
                        {content.tagline && <div className={"tagline"}>{content.tagline}</div>}
                    </div>
                )}
                {((content && content.html) || content.richText) && (
                    <div className="md-content">
                        {content && content.html && content.html.length > 0 && <div className={`side-menu-custom logged-out`} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content.html) }}></div>}
                        {content && content.richText && <div className={`side-menu-custom`}>{richTextContent(content)}</div>}
                    </div>
                )}
            </div>
        </div>
    );
}



/**
 * 
 * @returns Top and Bottom content for sidemenu
 */
export const SideMenuTopContent = (props: { sidemenuTopContent?: menuContent[]; collapsed?: boolean }) => {
    const isLoggedIn = useSelector((app: AppState) => app.user.user?.loggedIn);
    if (props.sidemenuTopContent && props.sidemenuTopContent?.length <= 0) {
        return <></>;
    }

    return (
        <>
            {props.sidemenuTopContent &&
                !!props.sidemenuTopContent.length &&
                props.sidemenuTopContent.map((content, i) => {
                    if (content.collapsedMode) return;
                    if ((content.loggedIn && isLoggedIn) || (!content.loggedIn && !isLoggedIn)) return <SideMenuContent key={"b" + i} content={content} isLoggedIn={isLoggedIn} classname="menu-top-content" />;
                })}
        </>
    );
};


export const SideMenuBottomContent = (props: { sidemenuBottomContent?: menuContent }) => {
    const isLoggedIn = useSelector((app: AppState) => app.user.user?.loggedIn);
    if (!props.sidemenuBottomContent) {
        return <></>;
    }

    return <SideMenuContent content={props.sidemenuBottomContent} isLoggedIn={isLoggedIn} classname="menu-bottom-content" />;
};



/**
 * 
 * @returns Helpers to render contentful images and rich text
 */

export const csmImageUrl = (image?: ImageObject) => {
    return image && image.fields && image.fields.file && image.fields.file.url ? image.fields.file.url : "";
};

const richTextContent = (st: any) => {
    if (st?.textLink?.startsWith("/")) {
        return (
            <InternalLink to={st?.textLink} className={st.cssClassname}>
                {st.richText && renderContentAsComponent(st.richText, richTextOptionsSideMenu)}
            </InternalLink>
        );
    } else if (st?.textLink) {
        return (
            <a href={st.textLink} className={st.cssClassname}>
                {st.richText && renderContentAsComponent(st.richText, richTextOptionsSideMenu)}
            </a>
        );
    }
};

export const contentfulImageUrl = (image?: ImageObject) => {
    return image && image.fields && image.fields.file && image.fields.file.url ? image.fields.file.url : "";
};

export const ContentfulImage = (props: { image?: ImageObject }) => <img src={props.image && props.image.fields && props.image.fields.file && props.image.fields.file.url ? props.image.fields.file.url : ""} />;


export const HamburgerIcon = (props: { onClick?: () => void }) => (
    <span className={"hamburger-bars sidemenu-toggle"} onClick={() => props.onClick && props.onClick()}>
        <span className={"material-icons"}>menu</span>
    </span>
);

export const MenuCloseButton = (props: { onClick?: () => void }) => (
    <span className={"hamburger-bars sidemenu-toggle"} onClick={() => props.onClick && props.onClick()}>
        <span className={"material-icons"}>close</span>
    </span>
);